// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__dgfEs","modal__close-icon":"modal_modal__close-icon__nEmM3","modal__overlay":"modal_modal__overlay__b6CnD"};